import { HttpErrorResponse } from "@angular/common/http";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DxValidationGroupComponent } from "devextreme-angular";
import notify from "devextreme/ui/notify";
import {
    IOcbFTPRemotePlatform,
    IOcbSaveFtpRemotePlatform,
    RemotePlatformsService
} from "../../core";

@Component({
    selector: 'app-remote-platform-ftp',
    templateUrl: './remote-platform-ftp-popup.component.html',
    styleUrls: ['./remote-platform-ftp-popup.component.scss']
})
export class FtpPopupComponent {
    @Input() public platform?: IOcbFTPRemotePlatform;
    @Input() public readOnly: boolean = false;
    public visible: boolean = false;

    @Output() public onClose: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ViewChild('remotePlatformValidation')
    private remotePlatformValidationGroup: DxValidationGroupComponent;

    private hasChanges: boolean = false;
    private isProgressBarVisible: boolean = false;
    private currentEnvironmentId: string = '';
    private updatePasswordPlaceHolder: string = '';

    private getNew(): IOcbFTPRemotePlatform {
        return {
            environmentId: this.currentEnvironmentId,
            name: null,
            server: null,
            account: null,
            password: null,
            downloadUnknownFiles: false,
            passiveMode: false,
            useSSL: true,
            useImplicitSSL: false,
            ipFiltering: false,
            isDisabled: false,
            bypassCertificateValidation: false,
            encryptDataChannel: false,
            useSslSessionResumption: false,
            port: 21
        };
    }

    private getPasswordPlaceHolder() { return this.platform.id ? this.updatePasswordPlaceHolder : ''; }

    private getSaveModel(): IOcbSaveFtpRemotePlatform {
        return {
            environmentId: this.platform.environmentId,
            name: this.platform.name,
            server: this.platform.server,
            port: this.platform.port,
            account: this.platform.account,
            password: this.platform.password,
            downloadUnknownFiles: this.platform.downloadUnknownFiles,
            passiveMode: this.platform.passiveMode,
            useSSL: this.platform.useSSL,
            useImplicitSSL: this.platform.useImplicitSSL,
            ipFiltering: this.platform.ipFiltering,
            isDisabled: this.platform.isDisabled,
            bypassCertificateValidation: this.platform.bypassCertificateValidation,
            encryptDataChannel: this.platform.encryptDataChannel,
            useSslSessionResumption: this.platform.useSslSessionResumption
        } as IOcbSaveFtpRemotePlatform;
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) {
                message = error.error.message;
            } else if (error.error.hasOwnProperty('name')) {
                message = error.error.name;
            } else {
                message = error.error;
            }
        } else {
            message = error;
        }

        notify(message, 'error', 3000);
    }

    constructor(private remotePlatformsService: RemotePlatformsService, private route: ActivatedRoute, private translateService: TranslateService) {
        this.getPasswordPlaceHolder = this.getPasswordPlaceHolder.bind(this);
        this.validateCredentials = this.validateCredentials.bind(this);
        this.route.params.subscribe(_ => {
            this.currentEnvironmentId = this.route.snapshot.params.id;
            this.platform = this.getNew();
        });
        this.translateService.get('remotePlatforms.lblFillToChangeCurrentPassword').subscribe(placeHolder => {
            this.updatePasswordPlaceHolder = placeHolder;
        });
    }

    public onHidden() {
        this.platform = this.getNew();
        this.onClose.emit(this.hasChanges);
    }

    public onShown() { this.hasChanges = false; }

    private validateCredentials() { return this.platform.id || this.platform.password; }

    private save() {
        const validationResult = this.remotePlatformValidationGroup.instance.validate();
        if (!validationResult.isValid) return;
        this.isProgressBarVisible = true;
        const saveModel = this.getSaveModel();
        if (!this.platform.id) {
            this.remotePlatformsService.addFTPRemotePlatform(saveModel).subscribe({
                next: _ => {
                    this.isProgressBarVisible = false;
                    this.hasChanges = true;
                    this.visible = false;
                },
                error: (err) => this.handleError(err)
            });
        }
        else {
            this.remotePlatformsService.updateFTPRemotePlatform(this.platform.id, saveModel).subscribe({
                next: _ => {
                    this.isProgressBarVisible = false;
                    this.hasChanges = true;
                    this.visible = false;
                },
                error: (err) => this.handleError(err)
            });
        }
    }
}